/**
 * `console.error` messages `main.tsx` wants suppressed entirely — known-noisy Carbon /
 * React warnings that don't indicate an actual bug in this app. String-matched only:
 * see `shouldSuppress` for why.
 */
export const SUPPRESSED_WARNINGS = [
  'Warning: Failed %s type: %s%s',
  'Warning: validateDOMNesting',
  'does not exist in data groups',
  'for a non-boolean attribute',
];

/**
 * Whether a `console.error` call should be swallowed rather than forwarded.
 *
 * Only ever matches when the first argument is a string: `console.error` is also called
 * with a non-string first argument (TanStack Query logs the error OBJECT for a failed
 * query), and `String.prototype.indexOf` does not exist on an `Error`, a number, or
 * `undefined` — matching against a non-string used to make the override itself throw on
 * every dashboard page.
 */
export function shouldSuppress(firstArg: unknown): boolean {
  return typeof firstArg === 'string' && SUPPRESSED_WARNINGS.some((entry) => firstArg.indexOf(entry) > -1);
}

/**
 * Builds a `console.error` replacement that drops suppressed messages and forwards
 * everything else — including a non-string first argument — to `originalConsoleError`
 * untouched.
 */
export function createFilteredConsoleError(
  originalConsoleError: (...args: unknown[]) => void
): (...args: unknown[]) => void {
  return function filterWarnings(...args: unknown[]) {
    if (!shouldSuppress(args[0])) {
      originalConsoleError(...args);
    }
  };
}
